import { h, Component } from 'preact';
import shallowEqual from '@os/shallow-equal';
import Provider from 'preact-context-provider';
import { configure } from '../config';
import createLocationModel from './';

function noop() {}

let Model;
export default function withLocationModel(mapStateToProps = noop, mapDispatchToProps = noop) {
	return function enhance(Child) {
		return configure('locationServiceOrigin,supportInternationalLocations,defaultLocation')(class LocationModelProvider extends Component {
			handleLocations = (locations) => {
				this.setState(locations);
			}

			componentWillMount() {
				let { locationServiceOrigin, supportInternationalLocations, defaultLocation } = this.props;
				if (!Model) {
					Model = createLocationModel({
						config: {
							apiOrigin: locationServiceOrigin,
							international: supportInternationalLocations,
							defaultLocation
						}
					});
				}
				this.destroy = Model.on.refresh(this.handleLocations);
			}

			componentWillReceiveProps({ locationServiceOrigin }) {
				if (locationServiceOrigin && this.props.locationServiceOrigin !== locationServiceOrigin) {
					Model.setAPIOrigin(locationServiceOrigin);
				}
			}

			shouldComponentUpdate(nextProps, nextState) {
				return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState);
			}

			componentWillUnmount() {
				this.destroy && this.destroy();
			}

			render(props, state) {
				const mappedProps = mapStateToProps(state);
				const mappedActions = mapDispatchToProps(Model, { ...mappedProps, ...props });
				return h(Child, { ...mappedProps, ...mappedActions, ...props });
			}
		});
	};
}

@configure('locationServiceOrigin,supportInternationalLocations,defaultLocation')
export class LocationProvider extends Component {
	componentWillMount() {
		let { locationServiceOrigin, supportInternationalLocations, defaultLocation } = this.props;
		if (!Model) {
			Model = createLocationModel({
				config: {
					apiOrigin: locationServiceOrigin,
					international: supportInternationalLocations,
					defaultLocation
				}
			});
		}
	}

	componentWillReceiveProps({ locationServiceOrigin }) {
		if (locationServiceOrigin && this.props.locationServiceOrigin !== locationServiceOrigin) {
			Model.setAPIOrigin(locationServiceOrigin);
		}
	}

	render({ children, ...props }, state) {
		const child = children && children[0];
		return h(Provider, { location: Model }, child);
	}
}
